// 定价状态
export const STATUS_WAIT = 'pending'
export const STATUS_DONE = 'priced'
export const STATUS_CHANGING = 'changing'
export const MapStatus = {
  [STATUS_CHANGING]: { label: '改价中', type: 'warn' },
  [STATUS_DONE]: { label: '已定价', type: 'success' },
  [STATUS_WAIT]: { label: '待定价', type: 'info' }
}
